import { toast } from "react-hot-toast";
import { apiConnector } from "../apiconnector";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Super Admin Dashboard APIs
export const getSuperAdminDashboard = async () => {
  try {
    const response = await apiConnector(
      "GET", 
      `${BASE_URL}/superadmin/dashboard`,
      null,
    
    );
    return response;
  } catch (error) {
    console.error("GET_SUPERADMIN_DASHBOARD_API ERROR:", error);
    throw error;
  }
};

export const getPlantData = async (plantId) => {
  try {
    const response = await apiConnector(
      "GET", 
      `${BASE_URL}/superadmin/plant/${plantId}/data`,
      null,
    );
    return response;
  } catch (error) {
    console.error("GET_PLANT_DATA_API ERROR:", error);
    throw error;
  }
};

// Plant Management APIs
export const createPlant = async (plantData) => {
  const toastId = toast.loading("Creating plant...");
  try {
    const response = await apiConnector(
      "POST", 
      `${BASE_URL}/superadmin/plants`,
      plantData,
    );
    
    if (response.success) {
      toast.success("Plant created successfully");
    }
    toast.dismiss(toastId);
    return response;
  } catch (error) {
    toast.dismiss(toastId);
    toast.error(error.response?.data?.message || "Failed to create plant");
    throw error;
  }
};

export const getPlants = async () => {
  try {
    const response = await apiConnector(
      "GET", 
      `${BASE_URL}/superadmin/plants`,
      null,
    );
    return response;
  } catch (error) {
    console.error("GET_PLANTS_API ERROR:", error);
    throw error;
  }
};

export const updatePlant = async (plantId, plantData) => {
  const toastId = toast.loading("Updating plant...");
  try {
    const response = await apiConnector(
      "PUT", 
      `${BASE_URL}/superadmin/plants/${plantId}`,
      plantData,
    );
    
    if (response.success) {
      toast.success("Plant updated successfully");
    }
    toast.dismiss(toastId);
    return response;
  } catch (error) {
    toast.dismiss(toastId);
    toast.error(error.response?.data?.message || "Failed to update plant");
    throw error;
  }
};

export const deletePlant = async (plantId) => {
  const toastId = toast.loading("Deleting plant...");
  try {
    const response = await apiConnector(
      "DELETE", 
      `${BASE_URL}/superadmin/plants/${plantId}`,
      null,
    );
    
    if (response.success) {
      toast.success("Plant deleted successfully");
    }
    toast.dismiss(toastId);
    return response;
  } catch (error) {
    toast.dismiss(toastId);
    toast.error(error.response?.data?.message || "Failed to delete plant");
    throw error;
  }
};

// Admin Assignment APIs
export const getAvailableAdmins = async () => {
  try {
    const response = await apiConnector(
      "GET", 
      `${BASE_URL}/superadmin/available-admins`,
      null,
    );
    return response;
  } catch (error) {
    console.error("GET_AVAILABLE_ADMINS_API ERROR:", error);
    throw error;
  }
};

export const assignAdminToPlant = async (plantId, adminId) => {
  const toastId = toast.loading("Assigning admin...");
  try {
    const response = await apiConnector(
      "PUT", 
      `${BASE_URL}/superadmin/plants/${plantId}/assign-admin`,
      { adminId },
      );
    
    if (response.success) {
      toast.success("Admin assigned successfully");
    }
    toast.dismiss(toastId);
    return response;
  } catch (error) {
    toast.dismiss(toastId);
    toast.error(error.response?.data?.message || "Failed to assign admin");
    throw error;
  }
};